import React from "react";

// @ts-ignore
import styles from "./styles.module.scss";

import { ReactComponent as CalanderIcon } from "./../../PlanDetails/ActionItems/Category/calander.svg";

import { ReactComponent as CompleteIcon } from "assets/svg/completeCircle.svg";
import { ReactComponent as InProgressIcon } from "assets/svg/inProgressCircle.svg";
import { ReactComponent as OnHoldIcon } from "assets/svg/onHoldOrange.svg";
import { ReactComponent as CancelIcon } from "assets/svg/cancelCircle.svg";
import { ReactComponent as TodoIcon } from "assets/svg/todoCircle.svg";

import { ReactComponent as StarIcon } from "assets/svg/star.svg";
import { ReactComponent as ClockIcon } from "assets/svg/clock.svg";
import moment from "moment";

// @ts-ignore
import { getTime } from "../../../utils/utility";
import { useSelector } from "react-redux";

type DataItem = {
  updated_at: string;
};

export default function ActionItemCardView({
  data,
  status,
  SetData,
  setIsNoteModel,
  setIsButtonDisabled,
  isShared,
}: {
  data: any;
  status: string;
  SetData: (data: any) => void;
  setIsNoteModel: (data: boolean) => void;
  setIsButtonDisabled: (data: boolean) => void;
  isShared: boolean;
}) {
  const { isUnActiveCategories } = useSelector((state: any) => state.plan.plan);

  const formateStatus = (status: any) => {
    switch (status) {
      case "1":
        return {
          name: "To Do",
          Icon: <TodoIcon />,
          color: "#e5e5e5aa",
        };

      case "2":
        return {
          name: "In Progress",
          Icon: <InProgressIcon />,
          color: "#1271a61a",
        };

      case "3":
        return {
          name: "On Hold",
          Icon: <OnHoldIcon />,
          color: "#ff99001a",
        };

      case "4":
        return {
          name: "Complete",
          Icon: <CompleteIcon />,
          color: "#59a3101a",
        };

      case "5":
        return {
          name: "Canceled",
          Icon: <CancelIcon />,
          color: "#f000001a",
        };

      default:
        return {
          name: "To Do",
          Icon: <TodoIcon />,
          color: "#ff99001a",
        };
    }
  };

  const sortData = data?.sort(
    (a: DataItem, b: DataItem) =>
      new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  const Status = formateStatus(status || 1);

  return (
    <>
      <div className={styles.cardViewWrapper}>
        <div className={styles.cardViewHeader}>
          <div
            className={styles.status}
            style={{
              backgroundColor: Status.color,
            }}
          >
            {Status?.name === "To Do" ? (
              <TodoIcon />
            ) : Status?.name === "In Progress" ? (
              <InProgressIcon />
            ) : Status?.name === "On Hold" ? (
              <OnHoldIcon />
            ) : Status?.name === "Complete" ? (
              <CompleteIcon />
            ) : (
              <CancelIcon />
            )}
            <h3>{Status.name}</h3>
            <h5>{data?.length}</h5>
          </div>
        </div>

        <div className={styles.cards}>
          {sortData?.map((item: any, index: number) => {
            const responsible_person = item?.responsible_person;
            const duration = item?.duration ? getTime(item?.duration) : "";
            const noProject = item?.project_name === "No Project Plan";
            const UserName =
              responsible_person?.first_name && responsible_person?.last_name
                ? responsible_person?.first_name.substring(0, 1) +
                  responsible_person?.last_name.substring(0, 1)
                : responsible_person?.name
                ? responsible_person?.name.split(" ").length > 1
                  ? responsible_person.name.split(" ")[0].substring(0, 1) +
                    responsible_person.name.split(" ")[1].substring(0, 1)
                  : responsible_person.name.substring(0, 2)
                : responsible_person?.email?.substring(0, 2);
            const findUnActiveCategory = isUnActiveCategories?.find(
              (state: any) => state.id === item?.category_details?.id
            );

            const updatedState =
              findUnActiveCategory === undefined
                ? item?.category_details?.is_active
                : Boolean(findUnActiveCategory?.isUnActive);

            return (
              <div
                className={styles.card}
                key={index}
                style={{
                  borderLeftColor: noProject ? "#A3A3A3" : "#1c8b7e",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (isShared) return;

                  if (!updatedState) {
                    setIsButtonDisabled(true);
                  }

                  SetData(item);
                  setIsNoteModel(true);
                }}
              >
                <div className={styles.top}>
                  {item?.status == "1" ? (
                    <TodoIcon />
                  ) : item?.status == "2" ? (
                    <InProgressIcon />
                  ) : item?.status == "3" ? (
                    <OnHoldIcon />
                  ) : item?.status == "4" ? (
                    <CompleteIcon />
                  ) : (
                    <CancelIcon />
                  )}

                  <h4>{item?.name}</h4>
                </div>
                <div className={styles.center}>
                  <div className={styles.weight}>
                    <StarIcon />

                    <span>{item?.weight}</span>
                  </div>
                  {item?.priority && (
                    <div
                      className={styles.perioty}
                      style={{
                        backgroundColor:
                          item?.priority === 3
                            ? "#FAD6D6"
                            : item?.priority === 2
                            ? "#D0E3ED"
                            : "#EDFDC6",
                        color:
                          item?.priority === 3
                            ? "#F00000"
                            : item?.priority === 2
                            ? "#1271A6"
                            : "#458C0A",
                      }}
                    >
                      {item?.priority === 3
                        ? "High"
                        : item?.priority === 2
                        ? "Medium"
                        : "Low"}
                    </div>
                  )}
                </div>
                <div className={styles.bottom}>
                  <div className={styles.dates}>
                    {item?.start_line && item?.dead_line && (
                      <h4>
                        <CalanderIcon />
                        {`${moment(item?.start_line).format(
                          "MMM D"
                        )} - ${moment(item?.dead_line).format("MMM D")}`}
                      </h4>
                    )}

                    <h4>
                      <ClockIcon />
                      {duration}
                    </h4>
                  </div>

                  {responsible_person?.display_picture ? (
                    <div className={styles.assigne_image}>
                      <img
                        src={responsible_person?.display_picture}
                        alt="assigne"
                      />
                    </div>
                  ) : (
                    <div className={styles.assigne}>{UserName}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
